import { useState, useEffect } from 'react';
import { getIntelligentPartnerTagGroups } from 'src/api/intelligentPartnerTagGroups';
import { IntelligentPartnerTagGroupFoundResponse } from 'src/api/types';

export function useCourseTags() {
    const [loading, setLoading] = useState(false);
    const [customerTagGroups, setCustomerTagGroups] = useState<
        IntelligentPartnerTagGroupFoundResponse[]
    >([]);

    const queryCustomerTagGroups = async () => {
        setLoading(true);
        try {
            const { data = [] } = await getIntelligentPartnerTagGroups({ params: { tagType: 1 } });
            setCustomerTagGroups(
                data
                    .map((item) => {
                        return {
                            ...item,
                            title: item.groupName,
                            value: `group-${item.id}`,
                            children: item.tags?.map((tag) => {
                                return {
                                    ...tag,
                                    title: tag.tagName,
                                    value: tag.id,
                                };
                            }),
                        };
                    })
                    .filter((item) => item.tags && item.tags.length)
            );
        } catch (error) {
            // 错误处理可以根据需求添加
            console.error('Failed to fetch course tags:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        queryCustomerTagGroups();
    }, []);

    return {
        loading,
        customerTagGroups,
        refreshTags: queryCustomerTagGroups,
    };
}
